// extracted by mini-css-extract-plugin
module.exports = {"heading-title":"HeadingTitle_heading-title__3k-jd","heading-title-separator":"HeadingTitle_heading-title-separator__xJE0L"};